import { Outlet } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth/authContext';

import { AppHeader } from './AppHeader';
import { MainNavigation } from './MainNavigation';

/**
 * Frame shared by every authenticated and public route. The presentation view
 * brings its own layout, so nothing here has to know about it.
 */
export function RootLayout() {
  const { session } = useAuth();

  return (
    <div className="bg-canvas text-fg min-h-dvh">
      <AppHeader />
      {session.status === 'authenticated' && <MainNavigation />}
      <main className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
}
